import React from "react";
import * as Icons from "lucide-react";
import { PROGERE_MODULE } from "@/config/progereModule";

// Bloc d'identité du module (coin sup. gauche) — Design System PROGÈRE V3.
// Structure identique dans tous les modules : PROG (or) · ÈRE (rouge) · NOM (blanc)
// + sous-titre écosystème + carte « MODULE ACTIF ».
export function ProgereModuleIdentity({ module = PROGERE_MODULE }) {
  const Icon = Icons[module.icon] || Icons.Boxes;
  return (
    <div className="progere-module-identity px-1 pt-1 pb-3" data-testid="module-identity">
      <div className="flex items-center gap-2.5 min-h-[46px] px-1">
        <div className="w-11 h-11 rounded-xl border border-[#F2BC2E]/50 bg-[#0b0b0b] flex items-center justify-center shrink-0 overflow-hidden">
          <img src="/progere-crm-monogram.png" alt="PROGÈRE" className="h-9 w-9 object-contain select-none" draggable="false" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="progere-brand-metal progere-brand-metal--small">
            <span className="progere-brand-prog">PRO</span>
            <span className="progere-brand-ere -ml-0.5">GÈRE</span>
            <span className="progere-brand-module">{module.name}</span>
          </div>
          <p className="progere-brand-subtitle truncate">{module.ecosystemSubtitle}</p>
        </div>
      </div>

      <div className="relative mt-2.5 flex items-center gap-2.5 min-h-[49px] px-3 py-2.5 rounded-xl overflow-hidden border border-[#F2BC2E]/[0.34]"
        style={{ background: "linear-gradient(135deg, rgba(33,27,10,0.72), rgba(11,10,8,0.96))", boxShadow: "inset 0 0 20px rgba(242,188,46,0.04), 0 4px 12px rgba(0,0,0,0.28)" }}>
        <span className="absolute top-0 left-[12%] w-[58%] h-px" style={{ background: "linear-gradient(90deg, transparent, rgba(255,210,86,0.7), transparent)" }} />
        <Icon size={17} className="text-[#F2BC2E] shrink-0" strokeWidth={1.8} />
        <div className="leading-tight">
          <p className="text-[8px] font-extrabold tracking-[0.18em] uppercase text-gray-500">Module actif</p>
          <p className="mt-0.5 text-[12px] progere-brand-panel-title progere-brand-panel-title--gold">{module.fullName}</p>
        </div>
      </div>
    </div>
  );
}
